import { Record } from 'immutable'

const ParsedBudgetBalanceErrorRecord = Record({
  type: undefined,
  code: undefined,
  message: undefined,
})

export default ParsedBudgetBalanceErrorRecord
